import {
  Home,
  HomeOutlined,
  Info,
  InfoOutlined,
  Logout,
  LogoutOutlined,
  Notifications,
  NotificationsOutlined,
  Person,
  PersonOutline,
  PlayCircle,
  PlayCircleFilledWhiteOutlined,
  ReceiptLong,
  ReceiptLongOutlined
} from '@mui/icons-material';

import newIcon from '@assets/misc-icons/new.png';
import { isClientCareerMosaic, isDesktop } from '@global/helpers/general';
import { mixpanel, trackingEvents } from '@global/monitoring/mixpanel';
import { logout } from '@redux/slices/auth';
import { navigateTo } from '@services/navigation';

import { configs } from '@containers/information/configs';
import { updateMiscStore } from '@redux/slices/misc';
import { store } from '@redux/store';
import { ReactNode } from 'react';

const ICON_FONT_SIZE = '2rem';

const setLastBaseUrlVisited = (url = '/') => {
  sessionStorage.setItem('lastBaseUrlVisited', url);
};

// Interface for individual link data
interface LinkData {
  onClick: () => void; // onClick is a function that returns void
  link: string; // link is a string URL
  icon: (selected: boolean) => ReactNode; // icon is a function that takes color and returns a JSX element (ReactNode)
  secondaryAction?: ReactNode;
  subtitle?: string; // subtitle is a string
  divider?: boolean; // divider is a boolean
}

// Interface for the entire linksData object
export interface LinksData {
  [key: string]: LinkData; // This allows for a dynamic key like 'Home', 'About', etc.
}

export const linksData: LinksData = {
  ...(!isClientCareerMosaic() && {
    Home: {
      onClick: () => {
        setLastBaseUrlVisited('/');
        navigateTo('/');
      },
      link: '/',
      icon: (selected) =>
        selected ? (
          <Home color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ) : (
          <HomeOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
        )
    }
  }),
  ...(!isClientCareerMosaic() && {
    Profile: {
      onClick: () => {
        setLastBaseUrlVisited('/profile');
        navigateTo('/profile');
      },
      link: '/profile',
      icon: (selected) =>
        selected ? (
          <Person color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ) : (
          <PersonOutline color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
        )
    }
  }),
  ...(!isDesktop()
    ? {
        Notifications: {
          onClick: () => {
            setLastBaseUrlVisited('/notifications');
            navigateTo('/notifications');
          },
          link: '/notifications',
          icon: (selected) =>
            selected ? (
              <Notifications color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
            ) : (
              <NotificationsOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
            )
        }
      }
    : {}),
  ...(!isClientCareerMosaic() && {
    Payments: {
      onClick: () => {
        setLastBaseUrlVisited('/transaction-history');
        navigateTo('/transaction-history');
      },
      link: '/transaction-history',
      icon: (selected) =>
        selected ? (
          <ReceiptLong color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ) : (
          <ReceiptLongOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
        )
    }
  }),
  ...(import.meta.env.VITE_DEMO_VIDEO_LINK && {
    'Watch Demo': {
      onClick: () => {
        // navigateTo('/transaction-history');
        mixpanel.track(trackingEvents.misc.events.watchVideo);
        store.dispatch(updateMiscStore({ openDemo: true }));
      },
      link: '',
      icon: (selected) =>
        selected ? (
          <PlayCircle color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ) : (
          <PlayCircleFilledWhiteOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ),
      secondaryAction: (
        <img src={newIcon} style={{ width: '24px', fontSize: ICON_FONT_SIZE }} alt="New Icon" />
      )
    }
  }),
  ...(configs.faq && !isDesktop()
    ? {
        'FAQs / Instructions': {
          onClick: () => {
            mixpanel.track(trackingEvents.misc.events.faq);
            setLastBaseUrlVisited('/instructions');
            navigateTo('/instructions');
          },
          link: '/instructions',
          icon: (selected) =>
            selected ? (
              <Info color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
            ) : (
              <InfoOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
            )
        }
      }
    : {}),

  // 'Export to HRMS': {
  //   onClick: () => {
  //     // navigateTo('/transaction-history');
  //   },
  //   link: '',
  //   subtitle: 'Coming Soon...',
  //   icon: (selected) =>
  //     selected ? (
  //       <IosShare color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
  //     ) : (
  //       <IosShareOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
  //     ),
  //   divider: true
  // },
  ...(!isClientCareerMosaic() && {
    'Log out': {
      onClick: () => {
        mixpanel.track(trackingEvents.auth.events.sign.out);
        store.dispatch(logout());
        // navigateTo('/login');
      },
      link: '/login',
      icon: (selected) =>
        selected ? (
          <Logout color={'primary'} sx={{ fontSize: ICON_FONT_SIZE }} />
        ) : (
          <LogoutOutlined color={'inherit'} sx={{ fontSize: ICON_FONT_SIZE }} />
        )
    }
  })
};
